module.exports = __webpack_public_path__ + "static/media/protocol_selected.6577d8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/protocol_selected.png
// module id = 55
// module chunks = 0 1